import GenericChartTooltip from 'components/common/GenericChartTooltip'
import LocalEmployeeOvertimeTooltipContent from 'containers/VerticalPage/common/Company/OverviewTab/EmployeeOvertimeTooltip/LocalEmployeeOvertimeTooltipContent'
import RestEmployeeOvertimeTooltipContent from 'containers/VerticalPage/common/Company/OverviewTab/EmployeeOvertimeTooltip/RestEmployeeOvertimeTooltipContent'
import { TooltipPaper } from 'containers/VerticalPage/common/Company/OverviewTab/EmployeeOvertimeTooltip/styles'
import { EmployeeOverviewDataKeys } from 'containers/VerticalPage/common/Company/OverviewTab/types'
import { TooltipProps } from 'recharts'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

interface EmployeeOvertimeTooltipProps extends TooltipProps<number, string> {
  localCountry: string
  hoveredDot?: EmployeeOverviewDataKeys | null
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

const EmployeeOvertimeTooltip = ({ payload, localCountry, hoveredDot, onMouseEnter, onMouseLeave }: EmployeeOvertimeTooltipProps) => {
  const relevantPayload = payload?.[0]

  if (!relevantPayload || !hoveredDot) return null
  return (
    <GenericChartTooltip>
      <Box position='relative' onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <Stack sx={{ ...TooltipPaper, maxHeight: 400, overflowY: 'auto' }}>
          {hoveredDot === EmployeeOverviewDataKeys.localAmount ? (
            <LocalEmployeeOvertimeTooltipContent localCountry={localCountry} relevantPayload={relevantPayload} />
          ) : (
            <RestEmployeeOvertimeTooltipContent localCountry={localCountry} relevantPayload={relevantPayload} />
          )}
        </Stack>
      </Box>
    </GenericChartTooltip>
  )
}

export default EmployeeOvertimeTooltip
